import { em, flex, px } from '@kerfjs/ui/css-values';
import { ListHeader } from '@kerfjs/ui/list-header';
import { Row } from '@kerfjs/ui/row';
import type { SafeHtml } from 'kerfjs';

/**
 * The line item's shared label column (Quotes, AI Analysis, HS Code, Decision):
 * a fixed 9em track configured through Row's typed `flex`, so no app CSS
 * restyles the Row (HS2-1PQQ6Y).
 */
export function LineItemSectionLabel({ label }: { label: string }): SafeHtml {
  return (
    <Row flex={flex(0, 0, em(9))}>
      <ListHeader label={label} inline />
    </Row>
  );
}

/**
 * The values beside a section label. A basis wide enough for a section's controls keeps them
 * beside the label in a wide card; a narrow card wraps them below the label at full width
 * instead of squeezing every value onto its own line (HS2-DME204). Pair it with `wrap` on the
 * section's outer Row.
 */
export const LINE_ITEM_SECTION_VALUES_FLEX = flex(1, 1, px(280));
